import PASSWORD_TYPES from './password/types';
import CANCEL_ACCOUNT_TYPES from './cancel-account/types';
import CUSTOMER_ADDRESS_TYPES from './customer-address/types';
import CUSTOMER_BANK_ACCOUNT_TYPES from './customer-bank-account/types';

export default {
  ...PASSWORD_TYPES,
  ...CANCEL_ACCOUNT_TYPES,
  ...CUSTOMER_ADDRESS_TYPES,
  ...CUSTOMER_BANK_ACCOUNT_TYPES,
};
